// Anlagen & Wartung: gemeinsame Helfer für Projektregister, Verträge und KI-PostManager

// Projekttypen, bei denen das Register „Anlagen & Wartung“ standardmäßig sichtbar ist
// (in Einstellungen › Projekttypen › Tab-Konfiguration je Typ an-/abschaltbar)
export const WARTUNG_PROJEKTTYPEN = new Set(['Immobilienverwaltung', 'Bauvorhaben', 'Handwerksauftrag']);

export const wartungTabSichtbar = (tabConfig, projectType) =>
  tabConfig?.wartung === true || (tabConfig?.wartung === undefined && WARTUNG_PROJEKTTYPEN.has(projectType));

export const ANLAGEN_ARTEN = {
  aufzug: 'Aufzug',
  brandschutz: 'Brandschutz',
  elektro: 'Elektroanlage',
  heizung: 'Heizung',
  klima: 'Klimaanlage',
  lueftung: 'Lüftungsanlage',
  photovoltaik: 'Photovoltaik',
  sanitaer: 'Sanitär',
  sonstiges: 'Sonstiges',
};

export const AMPEL_FARBEN = {
  rot: 'bg-red-100 text-red-700 border-red-200',
  gelb: 'bg-amber-100 text-amber-700 border-amber-200',
  gruen: 'bg-green-100 text-green-700 border-green-200',
  offen: 'bg-gray-100 text-gray-600 border-gray-200',
};

// JJJJ-MM-TT → TT.MM.JJJJ
export const datumDe = (iso) => {
  if (!iso) return '—';
  const [j, m, t] = String(iso).slice(0, 10).split('-');
  return j && m && t ? `${t}.${m}.${j}` : String(iso);
};

export const faelligText = (anlage) => {
  if (!anlage?.faellig_am) return 'kein Termin';
  const tage = anlage.tage_bis_faellig;
  if (tage < 0) return `überfällig seit ${datumDe(anlage.faellig_am)}`;
  if (tage === 0) return 'heute fällig';
  return `fällig am ${datumDe(anlage.faellig_am)}`;
};

export const VERTRAGSARTEN = {
  abo: 'Abo', fitness: 'Fitness', gas: 'Gas', handy: 'Handy', internet: 'Internet', miete: 'Miete',
  sonstiges: 'Sonstiges', streaming: 'Streaming', strom: 'Strom', versicherung: 'Versicherung', wartung: 'Wartung',
};

export const ZAHLUNGSRHYTHMEN = {
  monatlich: 'Monatlich', quartal: 'Quartalsweise', halbjaehrlich: 'Halbjährlich', jaehrlich: 'Jährlich', einmalig: 'Einmalig',
};
